<template>
  <span class="action" v-if="multipleTenant">
    <a-icon @click="showClick" type="swap" v-if="!searchTenantVisible"></a-icon>

    <component
      :is="searchTenantComp"
      :visible="searchTenantVisible"
      class="borders"
      title="搜索菜单"
      v-show="searchTenantVisible"
    >
      <a-select
        :defaultOpen="true"
        :getPopupContainer="(node) => node.parentNode"
        :open="true"
        :showArrow="false"
        @blur="hiddenClick"
        @change="searchMethods"
        class="search-input"
        optionFilterProp="children"
        placeholder="选择租户"
        v-model="tenantId"
      >
        <a-select-option :key="index" :value="site.id" v-for="(site,index) in tenantList">{{site.name}}</a-select-option>
      </a-select>
    </component>
  </span>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import { TENANTLIST, TENANT_ID } from '@/store/mutation-types'

  export default {
    name: 'UserTenant',
    components: {

    },
    // 定义属性
    data () {
      return {
        multipleTenant: false,
        tenantList: [],
        searchTenantComp: 'span',
        searchTenantVisible: false,
        searchMenuOptions: [],
        tenantId: ''
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      const tenantList = Vue.ls.get(TENANTLIST) || []
      if (tenantList.length > 1) {
        this.multipleTenant = true
        this.tenantList = tenantList

      }
      this.getTenantId()

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      getTenantId () {
        let tenantid = Vue.ls.get(TENANT_ID)
        this.tenantId = tenantid
      },
      showClick () {
        this.searchTenantVisible = true
      },
      searchMethods (val) {

        this.searchTenantVisible = false
        const tenantId = this.$store.state.user.tenantid
        if (tenantId == val) return
        this.$store.dispatch('saveTenant', val)
        const tenantItem = this.tenantList.find(item => item.id == val)
        this.$notification.success({
          message: '提示',
          description: `切换到${tenantItem.name}`
        })
      },
      hiddenClick () {
        this.searchTenantVisible = false
      },
      triggerTenant () {
        const tenantId = this.tenantList[0].id
        // this.$store.dispatch('saveTenant', 2)
        //             Vue.ls.set(TENANTLIST, result.tenantList, 7 * 24 * 60 * 60 * 1000)

        const d = this.$store.state.user.tenantId

        // Vue.ls.get()
      }
    }
  }
</script>

<style lang='less' scoped>
  .user-wrapper .search-input {
    width: 180px;
    color: inherit;

    /deep/ .ant-select-selection {
      background-color: inherit;
      border: 0;
      border-bottom: 1px solid white;
      border-radius: 0;
      &__placeholder,
      &__field__placeholder {
        color: inherit;
      }
    }
  }
  .action:hover {
    background: transparent !important;
  }
</style>